<template>
	<div class="product">
		<div class="search-order">
			<div class="el-search vue-top-padding radius">
				<el-row :gutter="20">
					<el-col :span="3">
						<div class="el-left">
							<el-button
								size="small"
								icon="el-icon-printer"
								@click="exportOrder"
								>{{ $t("common.export") }}</el-button
							>
						</div>
					</el-col>
					<el-col :span="21">
						<div class="el-right">
							<el-form
								ref="order"
								:model="search"
								:inline="true"
								label-width="10px"
								size="small"
								class="demo-form-inline el-input-height"
							>
								<el-form-item prop="userName">
									<el-input
										v-model="search.userName"
										:placeholder="$t('user.userName')"
									></el-input>
								</el-form-item>
								<el-form-item prop="nickName">
									<el-input
										v-model="search.nickName"
										:placeholder="$t('user.nickName')"
									></el-input>
								</el-form-item>
								<el-form-item prop="equipmentNo">
									<el-input
										v-model="search.equipmentNo"
										:placeholder="$t('searchRenewalRecord.equipmentNo')"
									></el-input>
								</el-form-item>
								<el-form-item prop="state">
									<el-select
										v-model="search.state"
										clearable
										:placeholder="$t('user.zhangdanleixing')"
									>
										<el-option
											:key="0"
											:label="$t('user.status0')"
											:value="0"
										></el-option>
										<el-option
											:key="1"
											:label="$t('user.status1')"
											:value="1"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item prop="serviceType">
									<el-select
										v-model="search.serviceType"
										:no-data-text="$t('common.noData')"
										:no-match-text="$t('common.noData')"
										clearable
										:placeholder="$t('waterRecord.serviceTypeHolder')"
									>
										<el-option
											v-for="item in serviceTypeList"
											:key="item.id"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item prop="dateTime">
								<el-date-picker
									v-model="dateTime"
									type="datetimerange"
									:picker-options="pickerOptions"
									:default-time="['00:00:00', '23:59:59']"
									format="yyyy-MM-dd HH:mm:ss"
									value-format="yyyy-MM-dd HH:mm:ss"
									range-separator="-"
									:start-placeholder="$t('searchOrder.start')"
									:end-placeholder="$t('searchOrder.end')"
								></el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button
										type="primary"
										@click="onSubmit"
										icon="el-icon-search"
										>{{ $t("common.search") }}</el-button
									>
									<el-button @click="resetSearch()" icon="el-icon-refresh">{{
										$t("common.reset")
									}}</el-button>
								</el-form-item>
							</el-form>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="vue-padding radius">
			<el-table
				show-summary
				:sum-text="$t('myWallet.totaltitle')"
				:summary-method="getSummaries"
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="waterList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="orderNumber"
					:label="$t('user.orderNumber')"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column
				><el-table-column
					prop="userName"
					:label="$t('user.userName')"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="nickName"
					:label="$t('user.nickName')"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="price"
					:show-overflow-tooltip="true"
					:label="$t('waterRecord.price')"
					:align="'center'"
					:formatter="priceMatter"
				></el-table-column>
				<el-table-column
					prop="equipmentNo"
					:label="$t('searchRenewalRecord.equipmentNo')"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="state"
					:show-overflow-tooltip="true"
					:label="$t('user.zhangdanleixing')"
					:align="'center'"
					:formatter="stateMatter"
				></el-table-column>
				<el-table-column
					prop="type"
					:label="$t('waterRecord.serviceTypeHolder')"
					:align="'center'"
					:formatter="serviceTypes"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
					:label="$t('user.xfdatetime')"
					:align="'center'"
				></el-table-column>
			</el-table>
			<el-pagination
				v-if="page.totalSize > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	name: "Record",
	components: {},
	data() {
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t("TimeControl.week"),
						onClick(picker) {
						const end = new Date();
						end.setHours(23, 59, 59, 999);
						const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.month"),
						onClick(picker) {
						const end = new Date();
						end.setHours(23, 59, 59, 999);
						const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.year"),
						onClick(picker) {
						const end = new Date();
						end.setHours(23, 59, 59, 999);
						const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
			serviceTypeList: [],
			dateTime: "",
			search: {
				userName: "",
				nickName: "",
				equipmentNo: "",
				state: "",
				serviceType: "",
				startTime: "",
				endDate: "",
			},
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			waterList: [],
			heji: 0,
		};
	},
	mounted() {
		this.getServiceType();
		this.currentChange();
	},
	methods: {
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = this.$t("myWallet.totaltitle") + "：" + this.heji;
					return;
				}
				sums[index] = "N/A";
			});
			return sums;
		},
		// 获取流水类型
		getServiceType() {
			this.$api.dict("service_type").then(res => {
				if (res.code === 0) {
					this.serviceTypeList = res.data;
				}
			});
		},
		// 格式化流水类型
		serviceTypes(row) {
			return this.$cloud.getDictLabel(this.serviceTypeList, row.type);
		},
		// 格式化金额
		priceMatter(row) {
			return this.$currency(row.price);
		},
		// 格式化状态
		stateMatter(row) {
			// 截取当前数据到小数点后两位
			let realVal = "";
			if (parseInt(row.state) == 1) {
				realVal = this.$t("user.status1");
			} else if (parseInt(row.state) == 0) {
				realVal = this.$t("user.status0");
			}
			return realVal;
		},
		// 加载流水列表
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.myWallet.detail, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.waterList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
						this.heji = parseFloat(res.data.walletRecordDTO.price);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 提交查询搜索
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startTime = this.dateTime[0];
				this.search.endDate = this.dateTime[1];
			} else {
				this.search.startTime = "";
				this.search.endDate = "";
			}
			this.page.pageIndex = 1;
			this.currentChange();
		},
		// 重置条件
		resetSearch() {
			this.dateTime = "";
			this.search.userName = "";
			this.search.nickName = "";
			this.search.equipmentNo = "";
			this.search.state = "";
			this.search.serviceType = "";
			this.search.startTime = "";
			this.search.endDate = "";
			this.currentChange();
		},
		// 导出账单
		exportOrder() {
			this.$confirm(this.$t("user.export"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			})
				.then(() => {
					this.$api.download(this.$url.myWallet.recordexport, this.search);
				})
				.catch(err => {
					this.$message.error(err.msg);
				});
		},
	},
};
</script>

<style scoped>
.el-tag--mini {
	margin-right: 5px;
}
</style>
